<template>
     <div class="col-sm-12 col-xl-4 col-md-6">
                <div class="card">
                  <div class="card-header pb-0">
                    <h4>light Normal (600)</h4>
                  </div>
                  <div class="card-body typography">
                    <h1 class="f-w-600">Heading 1</h1>
                    <h2 class="f-w-600">Heading 2</h2>
                    <h3 class="f-w-600">Heading 3</h3>
                    <h4 class="f-w-600">Heading 4</h4>
                    <h5 class="f-w-600">Heading 5</h5>
                    <h6 class="f-w-600">Heading 6</h6>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-xl-4 col-md-6">
                <div class="card">
                  <div class="card-header pb-0">
                    <h4>Bold (700)</h4>
                  </div>
                  <div class="card-body typography">
                    <h1 class="f-w-700">Heading 1</h1>
                    <h2 class="f-w-700">Heading 2</h2>
                    <h3 class="f-w-700">Heading 3</h3>
                    <h4 class="f-w-700">Heading 4</h4>
                    <h5 class="f-w-700">Heading 5</h5>
                    <h6 class="f-w-700">Heading 6</h6>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-xl-4 col-md-6">
                <div class="card">
                  <div class="card-header pb-0">
                    <h4>Extra Bold (900)</h4>
                  </div>
                  <div class="card-body typography">
                    <h1 class="f-w-900">Heading 1</h1>
                    <h2 class="f-w-900">Heading 2</h2>
                    <h3 class="f-w-900">Heading 3</h3>
                    <h4 class="f-w-900">Heading 4</h4>
                    <h5 class="f-w-900">Heading 5</h5>
                    <h6 class="f-w-900">Heading 6</h6>
                  </div>
                </div>
              </div>
</template>